export default __webpack_public_path__ + "0c65f8e53c756ba4cfca3d40b9dac841.png";